import Vue from 'vue'
import wx from 'weixin-js-sdk';
import { getsignatureAPI } from "@/api/home/index.js"
//图片地址
Vue.prototype.coverUrl = function(cover, type) {
  if(type == 'file') {
    return process.env.BASE_API + '/file/' + cover
  } else {
    return process.env.BASE_API + '/file/file/?fileName=' + cover
  }
}


//默认封面--碎图
Vue.prototype.errImg = function(type) {
  let typeList = {
    'video': require('@/assets/common/default_video.png'),
    'audio': require('@/assets/common/default_audio.png'),
    'book': require('@/assets/common/default_book.png'),
    'special': require('@/assets/common/default_picture.png'),
    'member': require('@/assets/common/cover.png')
  }
  let img = event.srcElement;
  img.src = typeList[type]
  img.onerror = null; //防止闪图
}

//跳转页面
Vue.prototype.navigationFuc = function(name, query) {
  this.$router.push({ name, query })
}
Vue.prototype.wxShare = function(shareData={}){
  const urlPath = window.location.href.split("#")[0]
  let coverUrl = shareData.cover?(process.env.BASE_API + "/file/file/?fileName=" + shareData.cover +"&isOnLine=true"):'https://www.scpress.cn/logo.png'
  let desc = "中国市场出版社是国家发展和改革委员会主管主办的中央级出版社。近年来，市场出版社社会效益和经济效益连创新高，以出版高质量、高品质图书赢得了社会赞誉。出版社服务国家发展改革委中心工作的水平和力度不断提高，出版的图书荣获“中国最美的书”等众多荣誉，完成大中华文库等多项国家出版基金项目。"
  getsignatureAPI({url:urlPath}).then(res => {
    if(res.data.code == 0){
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.data.noncestr, // 必填，生成签名的随机串
        signature: res.data.data.signature, // 必填，签名
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
      });
      console.log(wx)
      wx.ready(function() {
        wx.updateAppMessageShareData({
            title: shareData.title||"中国市场出版社", // 分享标题
            desc:shareData.desc||desc, // 分享描述
            link: window.location.href, // 分享链接
            imgUrl: coverUrl, // 分享图标
            type: "", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function() {

            },
            cancel: function() {
                  // 用户取消分享后执行的回调函数
            }
        });
        //分享到朋友圈
        wx.updateTimelineShareData({
          title: shareData.title||"中国市场出版社", // 分享标题
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: coverUrl, // 分享图标
          success: function (res) {

          },
          cancel: function (res) {
          }
        });
        wx.error(function(res) {
        });
      })
    }
  })
}


// WEBPACK FOOTER //
// ./src/utils/common.js